import { IRestrictAccess } from 'next-common';
import { NEXT_ENTITY } from '@common/interfaces';
import { useClientQuery } from './useClientQuery';

interface IRestrictAccessResult {
  allRestrictAccess: IRestrictAccess[];
  loading: boolean;
}

export const useRestrictAccess = (): IRestrictAccessResult => {
  const { data, loading } = useClientQuery(NEXT_ENTITY.ALL_RESTRICT_ACCESS, { nextOptions: { cache: 'force-cache' } });
  return { allRestrictAccess: data, loading };
};
